import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function PrivacyChip() {
  return (
    <div className="inline-flex items-center space-x-1.5 bg-emerald-500/10 border border-emerald-500/20 px-2 py-1 rounded-full text-[10px] font-bold text-emerald-400 uppercase tracking-tight">
      <SafeIcon icon={FiIcons.FiShield} className="text-xs" />
      <span>You Control This • No GPS Tracking</span>
    </div>
  );
}